export const StringUtils = {
	openPhoneCall(phoneNumber) {
		if (!phoneNumber) return;
		window.open(`tel:${phoneNumber.replace('+886', '0')}`);
	},

	val(value) {
		return value ?? 'N/A';
	},

	rate(value) {
		return typeof value === 'number' ? `${(value * 100).toFixed(1)}%` : 'N/A';
	},

	usd(amount) {
		if (amount == null) return 'N/A';

		const isNegative = amount < 0;
		const absAmount = Math.abs(amount);
		const formattedNumber = absAmount
			.toString()
			.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

		return isNegative ? `-$${formattedNumber}` : `$${formattedNumber}`;
	},

	ntd(amount) {
		if (amount == null) return 'N/A';

		const isNegative = amount < 0;
		const absAmount = Math.abs(amount);
		const formattedNumber = absAmount
			.toString()
			.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

		return isNegative ? `-$${formattedNumber}` : `$${formattedNumber}`;
	},

	divide(numerator, denominator) {
		if (numerator == null || denominator == null || denominator === 0) {
			return 'N/A';
		}
		return `${numerator}/${denominator}`;
	},
};